import React from 'react'
import { Table, Modal, Avatar, Progress, Tag } from 'antd'
import { TableRowEditButton } from '../../components/AppButton'

class ItemListTable extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleDeleteButtonOnClick = this.handleDeleteButtonOnClick.bind(this)
  }

  handleDeleteButtonOnClick() {
    const handleTableOnDelete = () => { this.props.onDelete() }
    Modal.confirm({
      title: 'Удалить запись',
      content: 'Вы действительно хотите удалить запись?',
      onOk() {
        handleTableOnDelete()
      },
      onCancel() {
        // console.log('Cancel')
      },
    })
  }

  render() {
    const columns = [
      {
        title: 'ID',
        dataIndex: 'idnum',
        key: 'idnum',
        sorter: true,
      }, {
        title: 'Блокировка',
        dataIndex: 'n_lock',
        key: 'n_lock',
        render: record =>
          (record === '1' ? (
            <Tag color='red'>Включена</Tag>
          ) : (
            <Tag color='green'>Выключена</Tag>
          )),
      }, {
        title: 'Название',
        dataIndex: 's_name',
        key: 's_name',
        sorter: true,
      }, {
        title: 'Дата создания',
        dataIndex: 'd_create',
        key: 'd_create',
        sorter: true,
      }, {
      //   title: 'Активная рассылка',
      //   dataIndex: 'mailing',
      //   key: 'mailing',
      //   render: record => <Progress percent={parseInt(record)} status={parseInt(record) === 100 ? "success" : "active"} />
      // },{
        title: 'Действие',
        key: 'action',
        onHeaderCell: () => ({
          style: {
            whiteSpace: 'nowrap',
          },
        }),
        onCell: () => ({
          style: {
            whiteSpace: 'nowrap',
          },
        }),
        render: (row, record) => (
          <span>
            <TableRowEditButton to={`${this.props.editPath}/${record.idnum}`} />
          </span>
        ),
      },
    ]
    return (
      <Table
        rowKey={record => `item-row-${record.idnum}`}
        columns={columns}
        {...this.props}
      />
    )
  }
}

export default ItemListTable



// WEBPACK FOOTER //
// src/containers/UserList/Table.jsx